import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Download } from "lucide-react";
import { useTranslation } from "react-i18next";
import { downloadFile, toCSV, toTSV } from "@/lib/analytics/exportUtils";

interface Props {
  data: Record<string, any>[];
  filename?: string;
}

export function ExportButton({ data, filename = "hr-analytics" }: Props) {
  const { t } = useTranslation();

  const handleCSV = () => {
    downloadFile(toCSV(data), `${filename}.csv`, "text/csv;charset=utf-8;");
  };

  const handleExcel = () => {
    downloadFile(toTSV(data), `${filename}.xlsx`, "application/vnd.ms-excel");
  };

  const handlePDF = () => {
    window.print();
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          <Download className="h-4 w-4 mr-2" />
          {t("analytics.exportData")}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={handleCSV}>
          {t("analytics.exportCsv")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handleExcel}>
          {t("analytics.exportExcel")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={handlePDF}>
          {t("analytics.exportPdf")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
